<template>
    <div class="container">
        <section id="quoteGen">
            <div class="top_wrapper">
                <div class="flex items-center py-0 px-0 font-semibold">
                    <img
                      src="@/assets/images/icons/back-icon.svg"
                      @click="$router.go(-1)"
                      class="mr-4 cursor-pointer"
                    />Payment Receipt
                  </div>
                <div class="sm:block">
                    <img src="../svg//muleexLogo.svg" />
                </div>
            </div>
            <div class="green_wrapper">
                <div class="setting_wrapper">
                    <img src="../svg//settingicon.svg" class="mr-2" />
                    Payment Confrimation
                </div>
                <div>
                    Amount : ₦ {{ transaction && transaction.breakDown ? amountFomatter(transaction.totalValue) :
                    'N/A'}}
                </div>
            </div>
            <div class="cubes_item">
                <div class="item">
                    <div class="flex items-center width_flair">
                        <div class="w-6/12 text-right">Shipping ID #:</div>
                        <div class="w-6/12 pl-3">{{ transaction.shipping ? transaction.shipping.shippingReference :
                            'N/A'}}</div>
                    </div>
                    <div class="flex items-center width_flair">
                        <div class="w-6/12 text-right">Transaction Date:</div>
                        <div class="w-6/12 pl-3">{{ transactionDate }}</div>
                    </div>
                    <div class="flex items-center width_flair">
                        <div class="w-6/12 text-right">Payment Status:</div>
                        <div class="w-6/12 pl-3">{{ transaction.status || 'N/A' }}</div>
                    </div>
                </div>
                <div class="item">
                    <div class="flex items-center width_flair">
                        <div class="w-6/12 sm:w-full text-right">Gross Weight:</div>
                        <div class="w-6/12 sm:w-[120px] pl-3">{{ totalWeight }}</div>
                    </div>
                    <div class="flex items-center width_flair">
                        <div class="w-6/12 sm:w-full text-right">Net Shipment Cost:</div>
                        <div class="w-6/12 sm:w-[120px] pl-3">₦ {{ transaction && transaction.breakDown ?
                            amountFomatter(transaction.breakDown.netPrice) : 'N/A'}}</div>
                    </div>
                    <div class="flex items-center width_flair">
                        <div class="w-6/12 sm:w-full text-right">Discount:</div>
                        <div class="w-6/12 sm:w-[120px] pl-3">XXXXXX</div>
                    </div>
                    <div class="flex items-center width_flair font-semibold text-base">
                        <div class="w-6/12 sm:w-full text-right">Total Shipping Cost:</div>
                        <div class="w-6/12 sm:w-[120px] pl-3">₦ {{ transaction && transaction.breakDown ?
                            amountFomatter(transaction.totalValue) : 'N/A'}}</div>
                    </div>
                </div>
            </div>
        </section>


        <div class="mt-5 mb-10">
            <p class="">Send Receipt</p>
            <div class=" w-full pb-3 mt-2">
                <base-checkbox class="mr-3" v-model="senderEmail" label="Send to Sender’s email" />
                <base-checkbox class="mr-3" v-model="recieverEmail" label="Send to Receiver’s email" />
                <base-checkbox v-model="newEmail" label="Send to a new email" />
            </div>

            <div class="w-full">
                <label class="label">Email Address</label>
                <input v-model="email" type="email" class="input-mini" placeholder="--Enter--" />
            </div>
        </div>

        <div class="mt-16 flex justify-end">
            <button @click="sendReciept" class="quote_btn">
                Send Receipt
            </button>
            <div @click="generateQuote" class="download_btn">
                Download Receipt
                <img class="ml-3" src="../svg/downloadIcon.svg" />
            </div>
        </div>
    </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";

export default {
    data() {
        return {
            transactionId: this.$route.params.id,
            transaction: {},
            email: "",
            senderEmail: false,
            recieverEmail: false,
            newEmail: false
        };
    },
    mounted() {
        this.getReciept();
    },
    computed: {
        payload() {
            const array = this.addToArray()
            return {
               email: this.email,
               to: array
            }
        },
        totalWeight() {
            return this.transaction?.shipping?.packagees.reduce((acc, prod) => acc + Number(prod.estimatedWeight), 0) + this.transaction?.shipping?.packagees[0]?.unitOfWeight
        },
        transactionDate() {
            return moment(this.transaction.createdAt).format("DD-MM-YYYY")
        }
    },
    methods: {
        addToArray(){
            let array = []
            this.senderEmail && array.push('sender')
            this.recieverEmail && array.push('receiver')
            this.newEmail && array.push('custom')
            return array
        },
        async sendReciept() {
            await this.$_sendReciept(this.transactionId, this.payload)
        },
        generateQuote() {
            try {
                var element = document.getElementById("quoteGen");
                html2pdf(element);
            } catch (e) {
                // ...any code here
            }
        },
        async getReciept() {
            try {
                let response = await this.$_getReciept(this.transactionId);
                this.transaction = response.data.data.transaction;
                console.log("---transaction", this.transaction);
            } catch (error) {
                this.handleError(error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.quote_btn {
    @apply py-2 px-6 bg-primary-black text-white rounded mr-4
}

.quote_border {
    @apply border-r-2 border-r-black-default pr-2
}

.input-mini {
    @apply bg-gray-100 w-full max-w-[350px] py-2 px-2 border-2 border-gray-300 rounded-md;
}

.label {
    @apply w-full block;
}

.container {
    @apply bg-white p-2 sm:p-4 sm:px-4 px-12
}

.top_wrapper {
    @apply flex justify-between items-center my-3 py-2 border-b-[1px] border-gray-300
}

.green_wrapper {
    @apply bg-primary-green py-5 md:px-7 px-3 flex-row flex flex-wrap justify-between items-center text-white font-[500]
}

.setting_wrapper {
    @apply flex items-center flex-row;
}

.cubes_item {
    @apply flex flex-wrap mt-24 p-2 sm:p-4 md:p-6 bg-primary-lighterblue;

    .item {
        @apply md:w-[50%] w-full
    }
}

.width_flair {
    @apply w-full my-2
}

.download_btn {
    @apply bg-primary-yellow py-2 px-4 inline-flex items-center rounded font-semibold cursor-pointer
}
</style>